import { render } from "./BeneficiaryOpeningBalanceModal.vue?vue&type=template&id=72381eab&scoped=true"
import script from "./BeneficiaryOpeningBalanceModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryOpeningBalanceModal.vue?vue&type=script&lang=js"

import "./BeneficiaryOpeningBalanceModal.vue?vue&type=style&index=0&id=72381eab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72381eab"]])

export default __exports__